import { Badge } from "@devhop/ui";
import type {
  TemplateKind,
  TemplateVariableInfo,
} from "../api/types";

type Props = {
  variables: TemplateVariableInfo[];
  kind: TemplateKind;
  onInsert: (key: string) => void;
  layout?: "horizontal" | "vertical";
};

export function VariableChipList({
  variables,
  kind,
  onInsert,
  layout = "vertical",
}: Props) {
  const allowed = variables.filter((v) => v.kinds.includes(kind));

  if (allowed.length === 0) return null;

  if (layout === "horizontal") {
    return (
      <div className="rounded-lg border bg-muted/20 p-3">
        <p className="mb-2 text-muted-foreground text-xs">
          ກົດຕົວແປເພື່ອວາງໃນ template
        </p>
        <div className="flex flex-wrap gap-1.5">
          {allowed.map((v) => (
            <button
              key={v.key}
              type="button"
              onClick={() => onInsert(v.key)}
              className="group focus:outline-none"
              title={v.label}
            >
              <Badge
                variant="outline"
                className="cursor-pointer transition group-hover:border-primary group-hover:bg-primary group-hover:text-primary-foreground"
              >
                <code className="text-xs">{`{{${v.key}}}`}</code>
              </Badge>
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="text-muted-foreground text-xs">
        ກົດເພື່ອວາງຕົວແປໃສ່ template
      </div>
      <div className="flex flex-wrap gap-1.5">
        {allowed.map((v) => (
          <button
            key={v.key}
            type="button"
            onClick={() => onInsert(v.key)}
            className="group focus:outline-none"
            title={v.label}
          >
            <Badge
              variant="outline"
              className="cursor-pointer transition group-hover:border-primary group-hover:bg-primary group-hover:text-primary-foreground"
            >
              <code className="text-xs">{`{{${v.key}}}`}</code>
            </Badge>
          </button>
        ))}
      </div>
      <ul className="space-y-1 pt-2 text-muted-foreground text-xs">
        {allowed.map((v) => (
          <li key={v.key} className="flex items-baseline gap-2">
            <code className="text-[11px] text-foreground/70">{`{{${v.key}}}`}</code>
            <span>{v.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
